<template>
	<div class="distributor-address-list">
		<div class="common-header-wrap">
			<mt-header :title="getTitleText" class="common-header">
				<mt-button slot="left" icon="back" @click="goBack"></mt-button>
				<mt-button slot="right"  @click="goAdd">新增</mt-button>
			</mt-header>
		</div>
		<div v-if="address_list.length>0">
			<div v-for="item in address_list" :key="item.address_id">
				<div class="container">
					<div class="top-wrapper">
						<div class="title-wrapper">
              <label class="title">{{ item.label || item.address_detail }}</label>
						</div>
						<label class="desc address-text" style="-webkit-box-orient:vertical">{{ item.label === '' ? item.area_info : item.address_detail}}</label>
						<div class="bottom-line"></div>
					</div>
					<div class="bottom-wrapper">
						<div class="bottom-left-wrapper" @click="onDefault(item)">
							<label class="subtitle">
								<i v-if="item.address_is_default == 1" style="color: #fa800a;" class="iconfont">&#xe69d;</i><i v-else class="iconfont">&#xe69e;</i><span style="color: #EC9027">{{ $t('address.default_address') }}</span>
							</label>
						</div>
						<div class="bottom-right-wrapper">
							<div class="edit-wrapper" @click="onEdit(item.address_id)">
								<label class="subtitle">{{ $t('general.edit') }}</label>
							</div>
							<div class="edit-wrapper delete-wrapper" @click="onDelete(item)">
								<label class="subtitle">{{ $t('general.delete') }}</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div  v-else>
			<empty-record></empty-record>
		</div>

	</div>
</template>

<script>

import { Toast, Indicator } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getAddressList, delAddress, editAddress } from '../../../api/memberAddress'
import { AddressState } from '@src/const/address'
import { mapMutations, mapState } from 'vuex'
export default {
  components: {
    EmptyRecord
  },
  name: 'MemberAddressList',
  data () {
    return {
      address_list: [],
      o2o_errand_type: this.$route.query.o2o_errand_type !== undefined ? Number(this.$route.query.o2o_errand_type) : 1
    }
  },
  created: function () {
    this.getAddressList()
  },
  computed: {
    ...mapState({
      point: (state) => state.member.point
    }),
    getTitleText() {
      if (!this.isDeliveryPoint && this.$route.query.from === 'member_profile') {
        return this.$t('address.receiver_address')
      }
      return this.isDeliveryPoint ? this.$t('address.receiver_address') : this.$t('address.sender_address')
    },
    isDeliveryPoint () {
      return this.o2o_errand_type === AddressState.DELIVERY_POINT
    }
  },
  methods: {
	...mapMutations({
      memberPoint: 'memberPoint',    
    }),
    goBack () {
      this.$router.go(-1)
    },
    goAdd () {
      this.$router.push({ name: 'MemberAddressForm', query: { action: 'add', o2o_errand_type: Number(this.o2o_errand_type), from: this.$route.query.from } })
    },
    onDefault (address_info) {
      address_info.address_is_default = 1
      editAddress(address_info, address_info.address_id).then(
        (response) => {
          Indicator.close()
          this.getAddressList()
        }, (error) => {
          Indicator.close()
          Toast(error.message)
		})

		// 更改自身地址才設置memberPoint
		if (!this.isDeliveryPoint) {
			this.memberPoint({
				point: {
					address : address_info.address_detail,
					lat : address_info.address_latitude,
					lng : address_info.address_longitude
				}
			})
		}
    },
    onEdit (addressId) {
      this.$router.push({ name: 'MemberAddressForm', query: { address_id: addressId } })
    },
    onDelete (addressInfo) {
      Indicator.open()

      // 若目前的point使用的是此地址 必須清空
      if (addressInfo.address_detail === this.point.address && addressInfo.address_latitude === String(this.point.lat) && addressInfo.address_longitude === String(this.point.lng)) {
        this.memberPoint({
          point : {}
        })
      }

      delAddress(addressInfo.address_id).then(
        (response) => {
          this.getAddressList()
          Indicator.close()
        }, (error) => {
          Indicator.close()
          Toast(error.message)
      })
    },
    getAddressList () {
      getAddressList(this.o2o_errand_type).then(res => {
        this.address_list = res.result.address_list
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
	.distributor-address-list {
		.container {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: stretch;
			background-color: #fff;
			border-bottom: 1px solid #e8eaed;
		}
		.top-wrapper {
			position: relative;
			flex: 1;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: stretch;
			margin-top: 0.5rem;
		}
		.title-wrapper {
			height: 1rem;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: center;
			margin-top: 0.5rem;
			margin-left: 0.5rem;
		}
		.title {
			font-size: 0.8rem;
			color: #4e545d;
			margin-left: 0.5rem;
      font-weight: bold;
		}
		.default {
			width: 1.4rem;
			margin-left: 0.5rem;
			margin-right: 0.5rem;
			border: 1px solid #fa800a;
			color: $primaryColor;
			font-size: 0.5rem;
			text-align: center;
			border-radius: 0.1rem;
		}
		.desc {
			color: #999999;
			font-size: 0.7rem;
		}
		.address-text {
			margin-top: 0.5rem;
			margin-bottom: 0.5rem;
			margin-left: 1rem;
			margin-right: 0.5rem;
		}
		.bottom-line {
			position: absolute;
			height: 1px;
			left: 0.5rem;
			bottom: 0;
			right: 0.5rem;
			background-color: #e8eaed;
		}
		.bottom-wrapper {
			height: 2.5rem;
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			align-items: stretch;
		}
		.bottom-left-wrapper {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: center;
		}
		.bottom-right-wrapper {
			flex: 1;
			display: flex;
			flex-direction: row;
			justify-content: flex-end;
			align-items: stretch;
		}
		.edit-wrapper {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: center;
		}
		.delete-wrapper {
			margin-right: 0.5rem;
		}
		.indicator {
			width: 0.9rem;
			height: 0.9rem;
			margin-left: 0.75rem;
			margin-right: 0.5rem;
		}
		.icon {
			width: 0.9rem;
			height: 0.9rem;
			margin-left: 0.5rem;
		}
		.subtitle {
			font-size: 0.7rem;
			color: #999999;
			margin-top: 0.5rem;
			margin-bottom: 0.5rem;
			margin-left: 1rem;
			margin-right: 0.5rem;
		}
		.subtitle i{font-size:0.8rem;margin-right:.5rem;}
	}

</style>
